import React from "react"
import Layout from "../Layout"
import Contact from "../Contact"
import Partners from "../Partners"
import Gallery from "../Gallery"
import Hero from "../Hero"
import Numbers from "../Numbers"
import Summary2024 from "../Summary2024"

const IndexPage = ({ lang }) => (
  <Layout lang={lang}>
    <Hero lang={lang} type="hero2024" />
    <Numbers lang={lang} type="summary2024" />
    <Gallery lang={lang} />
    <Summary2024 lang={lang} />
    <Contact lang={lang} />
  </Layout>
)

export default IndexPage
